import React, { Component } from "react";
import { Grid, Header, Segment, Transition, Button, Modal, Image } from "semantic-ui-react";
import { connect } from "react-redux";
import menuBtnClose from "../../../semantic/dist/themes/fibrestream/assets/images/menu-close.svg";
import { googleTracking } from '../../../util';

const NotifyModal = props => {
  const { open, closeNotifyModal, message } = props;
  return (
    <Modal
      open={open}
      onClose={closeNotifyModal}
      size='small'
      className=" pos-relative mt-0 connecting-instruction modal__message"
      closeOnDimmerClick={false}
    >
      <Modal.Content scrolling className="ui centered grid mx-0 my-0 px-0 py-0">
        <Segment className="all-set-segment">
          <div className="avail__desc py-0 text-black" dangerouslySetInnerHTML={{ __html: message }} ></div>
        </Segment>
      </Modal.Content>
      <Button className="deny close" secondary onClick={closeNotifyModal}>
        <span className="times text-prime">
          <Image src={menuBtnClose} verticalAlign="middle" />
        </span>
      </Button>
    </Modal>
  );
};

class WoohooConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      notifyModal: false,
    };
    this.transitionNext = this.transitionNext.bind(this);
    this.closeNotifyModal = this.closeNotifyModal.bind(this);
    this.openNotifyModal = this.openNotifyModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
    googleTracking({ 'event': 'virtualPageview', 'pageview': '/not-prewired/step7/confirmation' });
  }

  transitionNext() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(10, "fade left")
    }, 400);
  }

  openNotifyModal(e) {
    e.preventDefault();

    this.setState({
      notifyModal: true
    });
  }

  closeNotifyModal() {

    this.setState({
      notifyModal: false
    });
  }

  render() {
    const { visible, animation, notifyModal } = this.state;
    const { timeslotObj, message } = this.props;
    return (
      <div>
        <Transition visible={visible} duration={500} animation={animation}>
          <div>
            <Header className="title__main" as="h1" textAlign="center">
              Confirmation
            </Header>
            <Grid className="instant-activation width__xs confirmation">
              <Grid.Row className="py-0">
                <Grid.Column className="px-0">
                  <Segment inverted textAlign="center">
                    <div className="circle-tick" />
                    <Header as="h3" className="title" textAlign="center">
                      GET EXCITED
                    </Header>
                    <Segment
                      className="sub__instant-activation ui inverted mx-4"
                      textAlign="center"
                    >
                      <p className="text-white f-size--14">
                        Your appointment is scheduled for <br />
                        <span className="itc-mdbold"> {timeslotObj.timeslot_day_desc} {timeslotObj.timeslot_from_time}-{timeslotObj.timeslot_to_time}.</span>
                        <br />
                        A confirmation has been sent to you by email.
                      </p>
                    </Segment>
                    <Button
                      secondary
                      className="btn--full text-white"
                      size="medium"
                      onClick={this.transitionNext}
                    >
                      CLOSE
                    </Button>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="px-4 py-0 learn-more__text">
                <Grid.Column textAlign="center">
                  <p className="itc-std-md f-size--14">
                    Our technician will arrive during the timeframe listed above.&nbsp;
                    <a className="text-prime cursor-pointer" onClick={this.openNotifyModal}>Learn how to prepare for your appointment.</a>
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <NotifyModal open={notifyModal} closeNotifyModal={this.closeNotifyModal} message={message} />
          </div>
        </Transition>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    timeslotObj: state.form.timeslotObj,
    message: state.form.message
  };
};

export default connect(mapStateToProps)(WoohooConfirmation);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-available/WoohooConfirmation.js